import React, { useState } from 'react';
import { useContent } from "../../hooks/useContent";
import styles from "./Contact.module.css";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

export default function Contact() {
  const { t } = useContent();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

  // Helper for image paths
  const getImagePath = (key, fallback) => {
    const path = t(key, fallback);
    if (path && path.startsWith('/uploads')) {
      return `${API_URL.replace('/api', '')}${path}`;
    }
    return path || fallback;
  };
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Message sent successfully!');
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h1 className={styles.title}>{t('contact.header.title', 'Contact Us')}</h1>
        <p className={styles.subtitle}>
          {t('contact.header.subtitle', 'Feel free to reach out. We would love to hear from you!')}
        </p>

        {/* Editorial Team */}
        <div className={styles.teamSection}>
          <h2 className={styles.sectionTitle}>{t('contact.team.title', 'Editorial Team')}</h2>

          <div className={styles.teamGrid}>
            <div className={styles.teamCard}>
              <div className={styles.teamAvatar}>
                <img src={getImagePath('contact.team.editor1.image', '/Images/Elyor.jpg')} alt={t('contact.team.editor1.name', 'Assistant professor. Saitov')} />
              </div>
              <div className={styles.teamInfo}>
                <h3 className={styles.teamName}>{t('contact.team.editor1.name', 'Assistant professor. Saitov')}</h3>
                <p className={styles.teamRole}>{t('contact.team.editor1.role', 'Scientific Editor-in-Chief')}</p>
                <p className={styles.teamAffiliation}>{t('contact.team.editor1.affiliation', 'University of Tashkent for Applied Sciences, Str. Gavhar 1, Tashkent 100149, Uzbekistan')}</p>
                <a href={`mailto:${t('contact.team.editor1.email', 'elyor.saitov@utas.uz')}`} className={styles.teamEmail}>
                  <FaEnvelope className={styles.emailIcon} />
                  {t('contact.team.editor1.emailLabel', 'email: elyor.saitov@utas.uz')}
                </a>
              </div>
            </div>

            <div className={styles.teamCard}>
              <div className={styles.teamAvatar}>
                <img src={getImagePath('contact.team.editor2.image', '/Images/Katerina.jpg')} alt={t('contact.team.editor2.name', 'Kateryna Shulakova')} />
              </div>
              <div className={styles.teamInfo}>
                <h3 className={styles.teamName}>{t('contact.team.editor2.name', 'Kateryna Shulakova')}</h3>
                <p className={styles.teamRole}>{t('contact.team.editor2.role', 'Technical Editor')}</p>
                <p className={styles.teamAffiliation}>{t('contact.team.editor2.affiliation', 'State University of Intelligent Technologies and Telecommunications, Ukraine')}</p>
                <a href={`mailto:${t('contact.team.editor2.email', 'k.shulakova@advaes-journal.com')}`} className={styles.teamEmail}>
                  <FaEnvelope className={styles.emailIcon} />
                  {t('contact.team.editor2.email', 'k.shulakova@advaes-journal.com')}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Conference Organization */}
        <div className={styles.teamSection}>
          <h2 className={styles.sectionTitle}>{t('contact.conf.title', 'Conference Organization')}</h2>

          <div className={styles.teamGridSmall}>
            <div className={styles.teamCardSmall}>
              <div className={styles.teamAvatarSmall}>
                <img src={getImagePath('contact.conf.chair.image', '/Images/conference-venue.jpg')} alt={t('contact.conf.chair.name', 'Conference Chairs')} />
              </div>
              <div className={styles.teamInfo}>
                <h3 className={styles.teamName}>{t('contact.conf.chair.name', 'Conference Chairs')}</h3>
                <p className={styles.teamAffiliation}>{t('contact.conf.chair.info', 'Information coming soon')}</p>
              </div>
            </div>

            <div className={styles.teamCardSmall}>
              <div className={styles.teamAvatarSmall}>
                <img src={getImagePath('contact.conf.secretary.image', '/Images/journal.jpg')} alt={t('contact.conf.secretary.name', 'Secretary of AdvAES')} />
              </div>
              <div className={styles.teamInfo}>
                <h3 className={styles.teamName}>{t('contact.conf.secretary.name', 'Secretary of AdvAES')}</h3>
                <p className={styles.teamAffiliation}>{t('contact.conf.secretary.info', 'Information coming soon')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.divider}></div>

        <div className={styles.content}>

          <h2 className={styles.centerTitle}>{t('contact.footer.title', 'Get in Touch')}</h2>

          <div className={styles.columnLeft}>
            <div className={styles.infoItem}>
              <FaMapMarkerAlt className={styles.icon} />
              <div>
                <strong>{t('contact.footer.addressLabel', 'Address:')}</strong>
                <span>{t('contact.footer.address', 'University of Tashkent for Applied Sciences, Str. Gavhar 1, Tashkent 100149, Uzbekistan')}</span>
              </div>
            </div>

            <div className={styles.infoItem}>
              <FaMapMarkerAlt className={styles.icon} />
              <div>
                <strong>{t('contact.footer.partnerLabel', 'Partner Address:')}</strong>
                <span>{t('contact.footer.partnerAddress', 'Anhalt University of Applied Sciences, Köthen, Germany')}</span>
              </div>
            </div>
          </div>

          <div className={styles.columnRight}>
            <div className={styles.infoItem}>
              <FaEnvelope className={styles.icon} />
              <div>
                <strong>{t('contact.footer.inquiriesLabel', 'General Inquiries:')}</strong>
                <span>{t('contact.footer.inquiries', 'info@advaes-journal.com')}</span>
              </div>
            </div>

            <div className={styles.infoItem}>
              <FaEnvelope className={styles.icon} />
              <div>
                <strong>{t('contact.footer.submissionsLabel', 'Submissions:')}</strong>
                <span>{t('contact.footer.submissions', 'submissions@advaes-journal.com')}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}